import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'app-about-dialog',
    templateUrl: './about-dialog.component.html',
    styleUrls: ['./about-dialog.component.css'],
    standalone: true,
    imports: [CommonModule,MatDialogModule,MatDividerModule]
})
export class AboutDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
